module.exports = __webpack_public_path__ + "img/clients-homewood.71477801.png";